// ======================================================================
// File Name       : multiLanguage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/content';
import { MULTI_LANGUAGE_STATUS } from '../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../constants/SelectBoxData';

const initialState = {
  filterData: {
    contentSecernId: '',
    contentName: '',
    multiLanguageStatus: MULTI_LANGUAGE_STATUS.ALL,
    documentMultiLanguageSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
  },
  documentMultiLanguageList: {
    allSecernIds: [],
    bySecernId: {},
  },
  languageInfo: {
    contentSecernId: '',
    contentName: '',
    contentType: '',
    allLanguageCodes: [],
    byLanguageCode: {},
  },
  recordNum: 0,
  multiLanguageInfo: {
    contentSecernId: '',
    contentName: '',
    languageCode: '',
    multiLanguageName: '',
    documentName: '',
    documentSize: '',
    uploadFile: '',
  },
  multiLanguageConfirmInfo: {
    contentSecernId: '',
    contentName: '',
    languageCode: '',
    documentName: '',
    documentSize: '',
    uploadFile: '',
  },
  multiLanguageProcessResultList: {
    allProcessIds: [],
    byProcessId: {},
  },
  multiLanguageProcessResultInfo: {
    multiLanguageProcessManagementIdAuto: 0,
    processStatus: 0,
    processType: '',
    processStartTime: '',
    processEndTime: '',
    languageCode: '',
    documentInfo: {},
    errorList: '',
  },
  editSuccess: false,
  translateSuccess: false,
  isRefreshData: false,
  isFirst: true,
  selectedLanguageCode: SELECT_BOX_DATA.TRANSLATION_LANGUAGE[0].value,
};

export default function multiLanguage(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.MULTI_LANGUAGE_LIST:
      return getMultiLanguageList(state, action);
    case ActionTypes.MULTI_LANGUAGE_EDIT:
      return getMultiLanguageEdit(state, action);
    case ActionTypes.MULTI_LANGUAGE_RECEIVE_TRANSLATE_RESPONSE:
      return receiveTranslateResponse(state, action);
    case ActionTypes.MULTI_LANGUAGE_EDIT_LANGUAGE_INFO:
      return editLanguageInfo(state, action);
    case ActionTypes.MULTI_LANGUAGE_DELETE_LANGUAGE_INFO:
      return deleteLanguageInfo(state, action);
    case ActionTypes.MULTI_LANGUAGE_REFRESH_LANGUAGE_INFO:
      return refreshLanguageInfo(state, action);
    case ActionTypes.MULTI_LANGUAGE_RECEIVE_CONFIRM_INFO:
      return receiveLanguageConfirmInfo(state, action);
    case ActionTypes.GET_MULTI_LANGUAGE_PROCESS_RESULT_LIST:
      return getMultiLanguageProcessResultList(state, action);
    case ActionTypes.GET_MULTI_LANGUAGE_PROCESS_DETAIL:
      return getMultiLanguageProcessDetail(state, action);
    case ActionTypes.MULTI_LANGUAGE_RESET_INFO:
      return resetMultiLanguageInfo(state, action);
    case ActionTypes.MULTI_LANGUAGE_RESET_STATUS:
      return resetMultiLanguageStatus(state, action);
    case ActionTypes.MULTI_LANGUAGE_SAVE_LANGUAGE_CODE:
      return saveMultiLanguageCode(state, action);
    default: {
      const { multiLanguageInfo, filterData } = initialState;
      return {
        ...state,
        multiLanguageInfo,
        filterData,
      };
    }
  }
}

function getMultiLanguageList(state, action) {
  const { data } = action;
  const { recordNum, documentContentList } = data;
  const documentMultiLanguageList = documentContentList.reduce(
    (acc, cur) => {
      const { contentSecernId } = cur;
      if (acc.allSecernIds.indexOf(contentSecernId) < 0) {
        acc.allSecernIds.push(contentSecernId);
        acc.bySecernId[contentSecernId] = cur;
      }
      return acc;
    },
    {
      bySecernId: {},
      allSecernIds: [],
    },
  );
  return { ...state, ...{ documentMultiLanguageList }, ...{ recordNum } };
}

function getMultiLanguageEdit(state, action) {
  const { documentContentList } = action;
  const { multiLanguageList } = documentContentList;
  const languageInfo = multiLanguageList.reduce(
    (acc, cur) => {
      const { languageCode } = cur;
      acc.byLanguageCode[languageCode] = cur;
      acc.allLanguageCodes.push(languageCode);
      return acc;
    },
    {
      contentSecernId: documentContentList.contentSecernId,
      contentName: documentContentList.contentName,
      documentType: documentContentList.documentType,
      byLanguageCode: {},
      allLanguageCodes: [],
    },
  );
  return {
    ...state,
    ...{ languageInfo },
  };
}

function receiveTranslateResponse(state, action) {
  return {
    ...state,
    translateSuccess: action.translateSuccess,
  };
}

function receiveLanguageConfirmInfo(state, action) {
  return {
    ...state,
    multiLanguageConfirmInfo: action.multiLanguageConfirmInfo,
  };
}

function editLanguageInfo(state, action) {
  const { multiLanguageInfo, multiLanguageConfirmInfo } = initialState;
  return {
    ...state,
    multiLanguageInfo,
    multiLanguageConfirmInfo,
    editSuccess: action.editSuccess,
  };
}

function refreshLanguageInfo(state, action) {
  return {
    ...state,
    isRefreshData: action.isRefreshData,
  };
}

function deleteLanguageInfo(state, action) {
  const { multiLanguageList } = initialState;
  return {
    ...state,
    multiLanguageList,
    editSuccess: true,
  };
}

function resetMultiLanguageInfo(state, action) {
  const { languageInfo, selectedLanguageCode } = initialState;
  return {
    ...state,
    languageInfo,
    selectedLanguageCode,
  };
}

function resetMultiLanguageStatus(state, action) {
  const { translateSuccess, editSuccess, isRefreshData, isFirst } = initialState;
  return {
    ...state,
    translateSuccess,
    editSuccess,
    isRefreshData,
    isFirst,
  };
}

function saveMultiLanguageCode(state, action) {
  return {
    ...state,
    selectedLanguageCode: action.languageCode,
    isFirst: false,
  };
}

function getMultiLanguageProcessResultList(state, action) {
  const { recordNum, multiLanguageProcessResultList } = action.resData;
  const resultList = multiLanguageProcessResultList.reduce(
    (acc, cur) => {
      const { multiLanguageProcessManagementIdAuto } = cur;
      if (acc.allProcessIds.indexOf(multiLanguageProcessManagementIdAuto) < 0) {
        acc.allProcessIds.push(multiLanguageProcessManagementIdAuto);
        acc.byProcessId[multiLanguageProcessManagementIdAuto] = cur;
      }
      return acc;
    },
    {
      byProcessId: {},
      allProcessIds: [],
      recordNum,
    },
  );
  return {
    ...state,
    multiLanguageProcessResultList: resultList,
  };
}

function getMultiLanguageProcessDetail(state, action) {
  const { multiLanguageProcessResultInfo } = action.resData;
  return {
    ...state,
    multiLanguageProcessResultInfo,
  };
}
